import axios from "axios";
const { CONFIG } = require("../config");

const getTourDetail = (authParams) => {
  const { clientId, authToken, filter } = authParams;
  const request = {
    method: "POST",
    url: `${CONFIG.LOCUS_API.BASE_URL}/client/${clientId}/tour-search?include=SEQUENCE,TASKS`,
    headers: { Authorization: `Bearer ${authToken}` },
    data: filter,
  };

  return axios(request);
};

const getTour = (authParams) => {
  const { clientId, authToken, tourId } = authParams;
  const request = {
    method: "GET",
    url: `${
      CONFIG.LOCUS_API?.[`LILY_BASE_URL_${clientId}`]
    }/client/${clientId}/tour/${tourId}`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return axios(request);
};

const getTourSealNumber = (authParams, isRider) => {
  const { clientId, authToken, tourId } = authParams;
  const config = {
    method: "POST",
    url: `${
      CONFIG.LOCUS_API?.[`LILY_BASE_URL_${clientId}`]
    }/client/${clientId}/tour/${tourId}?isRider=${isRider}`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return axios(config);
};

const getUserDetail = (authParams) => {
  const { clientId, authToken } = authParams;
  const config = {
    method: "GET",
    url: `${CONFIG.LOCUS_API.BASE_URL}/client/${clientId}/user?effectiveStatus=true`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return axios(config);
};


const getTeams = (authParams) => {
  const { clientId, authToken } = authParams;
  const request = {
    method: "GET",
    url: `${CONFIG.LOCUS_API.BASE_URL}/client/${clientId}/team`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return axios(request);
};

const getHomebases = (authParams) => {
  const { clientId, authToken } = authParams;
  const request = {
    method: "GET",
    url: `${CONFIG.LOCUS_API.BASE_URL}/client/${clientId}/homebase`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return axios(request);
};

const getOneOrder = (orderId, authParams) => {
  const { clientId, authToken } = authParams;
  const request = {
    method: "GET",
    url: `${CONFIG.LOCUS_API.OMS_BASE_URL}/client/${clientId}/order/${orderId}`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return axios(request);
};

const validateOrderIds = (
  requestObject,
  authParams,
) => {

  const { clientId, authToken } = authParams;
  const entityType = "ORDER";

  const request = {
    method: "POST",
    url: `${CONFIG.LOCUS_API.OMS_BASE_URL}/client/${clientId}/entitytype/${entityType}/validateids`,
    headers: { Authorization: `Bearer ${authToken}` },
    data: requestObject,
  };

  return axios(request);
};

const createBulkOrders = (
  requestObject,
  authParams,
) => {
  const { clientId, authToken } = authParams;
  const request = {
    method: "POST",
    url: `${CONFIG.LOCUS_API.OMS_BASE_URL}/client/${clientId}/order`,
    headers: { Authorization: `Bearer ${authToken}` },
    data: { requests: requestObject }
  };

  return axios(request).then(response => response.data).catch(error => {
    return {
      status: false,
      message: error.response.data.message,
      data: error.response.data,
    };
  });
};


const updateOrders = (
  orderId,
  requestObject,
  authParams,
) => {
  const { clientId, authToken } = authParams;
  const request = {
    method: "POST",
    url: `${CONFIG.LOCUS_API.OMS_BASE_URL}/client/${clientId}/order/${orderId}/update`,
    headers: { Authorization: `Bearer ${authToken}` },
    data: {
      patchBody: requestObject,
    },
  };

  return axios(request);
};


const createSpecialDelivery = (requestObject, authParams) => {
  const { clientId, authToken } = authParams;
  const request = {
    method: "POST",
    url: `${
      CONFIG.LOCUS_API?.[`LILY_BASE_URL_${clientId}`]
    }/client/${clientId}/special-delivery`,
    headers: { Authorization: `Bearer ${authToken}` },
    data: requestObject,
  };

  return axios(request);
};

const assignSpecialDelivery = (requestObject, authParams) => {
  const { clientId, authToken } = authParams;
  const request = {
    method: "POST",
    url: `${
      CONFIG.LOCUS_API?.[`LILY_BASE_URL_${clientId}`]
    }/client/${clientId}/special-delivery/assign`,
    headers: { Authorization: `Bearer ${authToken}` },
    data: requestObject,
  };

  return axios(request);
};

const getSpecialOrders = (authParams) => {
  const { clientId, authToken } = authParams;
  const request = {
    method: "GET",
    url: `${
      CONFIG.LOCUS_API?.[`LILY_BASE_URL_${clientId}`]
    }/client/${clientId}/special-delivery/orders`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return axios(request);
};

const getSpecialDeliveryFleet = (authParams) => {
  const { clientId, authToken, teamId } = authParams;
  const query = teamId ? `?teamId=${encodeURIComponent(teamId)}` : "";
  const request = {
    method: "GET",
    url: `${
      CONFIG.LOCUS_API?.[`LILY_BASE_URL_${clientId}`]
    }/client/${clientId}/special-delivery/fleet${query}`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return axios(request);
};

export const apiService = {
  getTourDetail,
  getTourSealNumber,
  getUserDetail,
  getTour,
  getTeams,
  getHomebases,
  getOneOrder,
  validateOrderIds,
  createBulkOrders,
  updateOrders,
  createSpecialDelivery,
  assignSpecialDelivery,
  getSpecialOrders,
  getSpecialDeliveryFleet,
};
